module.exports = __webpack_public_path__ + "img/linkedin.96adcba7.svg";